module.exports = __webpack_public_path__ + "img/GAME_MAHJONGSOLITAIRE2.ff71e4a1.jpg";